import React from 'react';
import ReactDOMServer from 'react-dom/server';

import {
  resolveResourceClick,
  resourceClickLinkProps,
  shouldUseNativeResourceClick,
} from 'app/components/Resources/resourceClickBehavior';
import { OpenInNewIcon, ResourceIcon } from 'app/components/shared/icons';

import {
  DataTypeResourceIconContainer,
  DataTypeResourcePillText,
  DataTypeResourcePillWrapper,
} from './styled';

export const dataTypeResourceContentModifier = (
  node: HTMLDivElement,
  push: (location: any, state?: any) => void,
  openResourceModal: (slug: string) => void
) => {
  node.querySelectorAll('[data-type="resources"], [data-type="resource"]').forEach((resource) => {
    const resourceFormat = resource.getAttribute('data-resource-type');
    const openInModalAttribute = resource.getAttribute('data-open-in-modal');
    const openInModal =
      openInModalAttribute === null ? undefined : openInModalAttribute === 'true';
    const slug = resource.getAttribute('data-slug');
    const name = resource.textContent;

    if (!slug) return;

    const decision = resolveResourceClick({
      slug,
      open_in_modal: openInModal,
      resource_format_name: resourceFormat,
    });

    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(
      React.createElement(DataTypeResourcePill, {
        name: name || '',
        opensInNewTab: decision.opensInNewTab,
      })
    );

    const pill = template.firstElementChild as HTMLAnchorElement;
    const linkProps = resourceClickLinkProps(decision);
    pill.setAttribute('href', linkProps.href);
    if (linkProps.target) pill.setAttribute('target', linkProps.target);
    if (linkProps.rel) pill.setAttribute('rel', linkProps.rel);

    pill.addEventListener('click', (event) => {
      if (shouldUseNativeResourceClick(event, decision)) return;

      event.preventDefault();
      if (decision.type === 'modal') openResourceModal(slug);
      if (decision.type === 'detail') push(decision.href);
      if (decision.type === 'detail_new_tab') {
        window.open(decision.href, '_blank', 'noopener,noreferrer');
      }
    });

    resource.replaceWith(pill);
  });
};

interface DataTypeResourcePillProps {
  name: string;
  opensInNewTab?: boolean;
}

const DataTypeResourcePill = ({ name, opensInNewTab }: DataTypeResourcePillProps) =>
  React.createElement(
    DataTypeResourcePillWrapper,
    null,
    React.createElement(
      DataTypeResourceIconContainer,
      null,
      React.createElement(ResourceIcon, {
        width: 16,
        height: 16,
        fill: 'var(--color-primary)',
      })
    ),
    React.createElement(DataTypeResourcePillText, null, name),
    opensInNewTab
      ? React.createElement(OpenInNewIcon, {
          width: 12,
          height: 12,
          fill: 'var(--color-text)',
        })
      : null
  );
